import { render, staticRenderFns } from "./CourseLayout.vue?vue&type=template&id=275a5fb7"
import script from "./CourseLayout.vue?vue&type=script&lang=js"
export * from "./CourseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('275a5fb7')) {
      api.createRecord('275a5fb7', component.options)
    } else {
      api.reload('275a5fb7', component.options)
    }
    module.hot.accept("./CourseLayout.vue?vue&type=template&id=275a5fb7", function () {
      api.rerender('275a5fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/layouts/CourseLayout.vue"
export default component.exports